import React, { useRef, useLayoutEffect, useState } from "react";
import { Box } from "@mui/material";
import FormModal from "../../common/formModal";
import LoadingScreen from "../../common/loadingScreen";
import { get, isEmpty } from "lodash";

const IFRAME_WIDTH = 1920;
const IFRAME_HEIGHT = 1080;
const ASPECT_RATIO = IFRAME_WIDTH / IFRAME_HEIGHT;

export const TemplatePreview: any = ({ handleClose, isOpen, useCasePreviewData }: any) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const onLoad = (e: any) => {
        try {
            const contWin = get(e, 'target.contentWindow');
            if (!contWin) {
                console.warn("Iframe contentWindow is not available.");
                return;
            }
            let contDoc;
            try {
                contDoc = contWin.document;
            } catch (err) {
                // Cross-origin access error
                console.warn("Cannot access iframe document due to cross-origin restrictions.", err);
                return;
            }
            if (contDoc) {                
                contDoc.querySelectorAll('*').forEach((e: any) => {
                    e.addEventListener(
                        'click',
                        function () {
                            e.stopPropagation();
                            e.preventDefault();
                            return false;
                        },
                        true // useCapture to catch all clicks in the capture phase
                    )
                })
                const style = contDoc.createElement('style');
                style.innerHTML = `[data-testid="data-testid dashboard controls"] { display: none !important; }.react-grid-layout { padding-top: 10px !important; }`;
                contDoc.head.appendChild(style);
            }            
            contWin.addEventListener(
                'click',
                function (event: any) {               
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                },
                true
            );
        } catch (err) {
            console.warn("Error in iframe onLoad handler:", err);
        }
    }
    // http://host.docker.internal:9080/grafana/d/aelytyxdd47i8e/grafana-throughput?orgId=1&theme=light&kiosk=true&from=2025-06-04T08:05:04.728Z&to=2025-06-11T08:05:04.728Z&timezone=browser&var-message_id=work_completed_01&var-Trend=24&var-asset_name=scape_sim&refresh=1m"
    return (
        <FormModal
            isOpen={isOpen}
            handleClose={handleClose}
            title={useCasePreviewData?.template_name || 'Template Preview'}
            maxWidth={false}
            fullWidth
            containerStyles={{ padding: 0 }}
            showclose={true}
            noclosepadding={true}
        >
            <Box
                ref={containerRef}
                sx={{
                    width: '100%',
                    maxWidth: '90vw',
                    maxHeight: '80vh',
                    aspectRatio: `${IFRAME_WIDTH} / ${IFRAME_HEIGHT}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        // width: `${IFRAME_WIDTH}px`,
                        // height: `${IFRAME_HEIGHT}px`,
                        transform: `scale(0.39)`,
                        // transformOrigin: 'top left',
                        boxShadow: 1,
                    }}
                >
                    {!isEmpty(useCasePreviewData) && useCasePreviewData?.grafana_uid && useCasePreviewData?.grafana_uid != '' ?
                        (<iframe
                            src={`${process.env.REACT_APP_GRAFANA_URL}/grafana/d/${useCasePreviewData?.grafana_uid}/?theme=light&kiosk=true`}
                            title={useCasePreviewData?.template_name || 'Template Preview'}
                            width={IFRAME_WIDTH}
                            height={IFRAME_HEIGHT}
                            style={{ border: '1px solid #E4D9D9', background: '#fff' }}
                            allowFullScreen
                            onLoad={onLoad}
                        />) : (<Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '48px',
                            }}>No Preview Available</Box>)
                    }
                </Box>

            </Box>
            <Box
                sx={{
                    fontSize: '16px',
                    color: '#5A5A5A',
                    fontWeight: 400,
                    textAlign: 'left',
                    margin: '24px auto 0 auto',
                    maxWidth: 'calc(90vw - 64px)',
                    lineHeight: 1.6,
                    paddingLeft: 0,
                    paddingRight: 0
                }}
            >
                <span style={{ fontWeight: 600, color: '#434D67' }}>Description:</span>{" "}
                {useCasePreviewData?.template_description
                    ? useCasePreviewData.template_description
                    : "No description available."
                }
            </Box>
        </FormModal>
    );
};

export default TemplatePreview;